import { CombinedState, combineReducers } from 'redux';

import document, { DocumentReducerType } from './document';
import messages, { MessagesReducerType } from './messages';
import assessment, { AssessmentReducerType } from './assessment';
import assessmentPage, { AssessmentPageReducerType } from './assessmentPage';
import assessmentSummary, {
  AssessmentSummaryReducerType,
} from './assessmentSummary';

export * from './assessment/selectors';
export * from './document/selectors';
export * from './assessmentPage/selectors';
export * from './assessmentSummary/selectors';

export type RootReducer = CombinedState<{
  document: DocumentReducerType;
  assessment: AssessmentReducerType;
  assessmentPage: AssessmentPageReducerType;
  assessmentSummary: AssessmentSummaryReducerType;
  messages: MessagesReducerType;
}>;

export default combineReducers({
  document,
  assessment,
  assessmentPage,
  assessmentSummary,
  messages,
});
